// import { defaults } from "axios";
import { useAuth } from "contexts/AuthContext";

export const LEGISLATIVE_DRAFTING_UI_RULES = {
    stakeholder_forward_to_registrar: { value: "stakeholder_forward_to_registrar" },
    stakeholder_forward_to_head: { value: "stakeholder_forward_to_head" },
    stakeholder_forward_to_prosecutor: { value: "stakeholder_forward_to_prosecutor" },
    head_forward_to_director: { value: "head_forward_to_director" },
    director_forward_to_prosecutor: { value: "director_forward_to_prosecutor" },
    director_forward_to_coordinator: { value: "director_forward_to_coordinator" },
    edit_director_forward_to_coordinator: { value: "edit_director_forward_to_coordinator" },
    coordinator_forward_to_prosecutor: { value: "coordinator_forward_to_prosecutor" },
    edit_coordinator_forward_to_prosecutor: { value: "edit_coordinator_forward_to_prosecutor" },
    registrar_forward_to_coordinator: { value: "registrar_forward_to_coordinator" },
    coordinator_forward_to_head: { value: "coordinator_forward_to_head" },
    edit_head_forward_to_director: { value: "edit_head_forward_to_director" },
    head_forward_to_prosecutor: { value: "head_forward_to_prosecutor" },
    head_forward_to_coordinator: { value: "head_forward_to_coordinator" },
    coordinator_forward_to_registrar: { value: "coordinator_forward_to_registrar" },

    additional_info: { value: "additional_info" },
    additional_info_action: { value: "additional_info_action" },
    additional_info_forward_to_stakeholder: { value: "additional_info_forward_to_stakeholder" },
    edit_additional_info: { value: "edit_additional_info" },
    additional_info_stakeholder: { value: "additional_info_stakeholder" },
    additional_info_submitted: { value: "additional_info_submitted" },

    draft_non_essential: { value: "draft_non_essential" },
    draft_and_additional_file: { value: "draft_and_additional_file" },
    forward_darft: { value: "forward_darft" },
    forward_darft_to_director: { value: "forward_darft_to_director" },
    forward_darft_to_head: { value: "forward_darft_to_head" },

    public_and_amended: { value: "public_and_amended" },
    edit_audit_draft: { value: "edit_audit_draft" },
    audit_submitted: { value: "audit_submitted" },

    final_approval: { value: "final_approval" },
    publish: { value: "publish" },
    broadcasted: { value: "broadcasted" },
    archived: { value: "archived" },

    internal_ui: { value: "internal_ui" },

    prosecutor_forward_to_coordinator: { value: "prosecutor_forward_to_coordinator" },
    prosecutor_forward_to_director: { value: "prosecutor_forward_to_director" },
    edit_prosecutor_forward_to_coordinator: { value: "edit_prosecutor_forward_to_coordinator" },
    edit_reference_number: { value: "edit_reference_number" },

    advice_summary: { value: "advice_summary" },

    upload_audit_target: { label: "Upload Audit Target", value: "upload_audit_target" },
    upload_audit: { label: "Upload Audit", value: "upload_audit" },
    team_appointed: { label: "Team Appointed", value: "team_appointed" },
    identification_complete_forward: { label: "Identification Complete Forward", value: "identification_complete_forward" },

    approve_or_schedule: { label: "Approve or Schedule", value: "approve_or_schedule" },
    approve_or_respond: { label: "Approve or Respond", value: "approve_or_respond" },
    schedule_awareness: { label: "Schedule Awareness", value: "schedule_awareness" },
    awareness_outcome: { label: "Awareness Outcome", value: "awareness_outcome" },

    training_manual_approve: { label: "Training Manual Approve", value: "training_manual_approve" },
    training_manual_approved: { label: "Training Manual Approved", value: "training_manual_approved" },
    training_schedule: { label: "Training Schedule", value: "training_schedule" },
    training_feedback: { label: "Training Feedback", value: "training_feedback" },
    distribute_to_zone: { label: "Distribute to Zone", value: "distribute_to_zone" },

    edit_assigned_team: { label: "Edit Assigned Team", value: "edit_assigned_team" },
    edit_target_approve: { label: "Target Approve", value: "edit_target_approve" },
    respond_amended: { label: "Respond Amended", value: "respond_amended" },
    oagb_management_head_approve_respond: { label: "Management Approve or Respond", value: "oagb_management_head_approve_respond" },
}

export const VISIBILITY_RULES: Record<string, Record<string, Record<string, string[]>>> = {
    "internal_ui": {
        all: {
            all: ["GeneralAttorney", "LRDIFUDDirector", "LRDIFUDeputy", "LegalResearchCoordinator", "LegalResearchProsecutor", "ZonalLIF"]
        }
    },

    "stakeholder_forward_to_registrar": {
        additional_info_submitted: {
            not_forwarded: [],
        },
        traning_request_submitted: {
            not_forwarded: [],
        },
    },
    stakeholder_forward_to_prosecutor: {
        additional_info_submitted: {
            not_forwarded: [],
        },
    },
    "additional_info_stakeholder": {
        "Waiting for Additional Information": {
            assigned_to_prosecutor: ["external"],
        },
        "additional_info_requested": {
            assigned_to_prosecutor: ["external"],
        },
        additional_info_submitted: {
            not_forwarded: [],
            "sent_to_registrar": [],
            "assigned_to_prosecutor": ["external"],
        },
    },
    "stakeholder_forward_to_head": {
        Submitted: {
            not_forwarded: [],
        },
        "Under review": {
            not_forwarded: [],
        },
        "Under Analysis": {
            not_forwarded: [],
        },
    },
    head_forward_to_prosecutor: {
        "draft_responded": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy"]
        },
        "pending": {
            "not_forwarded": ["GeneralAttorney", "LRDIFUDeputy"]
        }
    },
    head_forward_to_coordinator: {
        "draft_responded": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy"]
        },
        "identification_complete": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy", "ZonalLIF"]
        },
    },
    "head_forward_to_director": {
        "Submitted": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy"]
        },
        "Under review": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy"]
        },
        "Under Analysis": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy"]
        },
        "Back to Head": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy"]
        },
        "Final Approval": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy"]
        },
    },
    "edit_head_forward_to_director": {
        Submitted: {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy"]
        },
        "Under review": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy"]
        },
        "Under Analysis": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy"]
        },
        "Back to Head": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy"]
        },
    },
    "director_forward_to_coordinator": {
        "Back to Head": {
            "forwarded_to_director": ["LRDIFUDDirector"]
        },
        head_remark_submitted: {
            "forwarded_to_director": ["LRDIFUDDirector"]
        },
    },
    "director_forward_to_prosecutor": {
        "draft_responded": {
            "forwarded_to_director": ["LRDIFUDDirector"]
        },
        head_remark_submitted: {
            "forwarded_to_director": ["LRDIFUDDirector"]
        },
    },
    "edit_director_forward_to_coordinator": {
        head_remark_submitted: {
            "forwarded_to_director": ["LRDIFUDDirector"]
        },
        "Back to Head": {
            "forwarded_to_director": ["LRDIFUDDirector"]
        },
        // Director acting as head while the request sits at the head stage:
        // can write a remark and forward to a coordinator or set up the team.
        "Submitted": {
            "forwarded_to_head": ["LRDIFUDDirector"]
        },
        "Under review": {
            "forwarded_to_head": ["LRDIFUDDirector"]
        },
        "Under Analysis": {
            "forwarded_to_head": ["LRDIFUDDirector"]
        },
    },
    "coordinator_forward_to_prosecutor": {
        coordinator_remark_submitted: {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LRDIFUDDirector", "ZonalLIF"]
        },
        "Back to Coordinator": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LRDIFUDDirector", "ZonalLIF"]
        },
        additional_info_submitted: {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LRDIFUDDirector", "ZonalLIF"]
        },
        "pending": {
            "not_forwarded": ["LRDIFUDDirector", "LegalResearchCoordinator", "ZonalLIF"]
        },
        "session_scheduled": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LRDIFUDDirector", "ZonalLIF"]
        },
        team_assigned: {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LRDIFUDDirector", "ZonalLIF"]
        },
    },
    "coordinator_forward_to_registrar": {
    },
    "coordinator_forward_to_head": {
        audit_submitted: {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "ZonalLIF"]
        },
        "identification_in_progress": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "ZonalLIF"],
            "forwarded_to_director": ["LRDIFUDDirector"]
        },
    },
    "edit_coordinator_forward_to_prosecutor": {
        director_remark_submitted: {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LRDIFUDDirector", "ZonalLIF"]
        },
        "Back to Coordinator": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LRDIFUDDirector", "ZonalLIF"]
        },
        "all": {
            "all": ["LegalResearchCoordinator", "LRDIFUDDirector", "ZonalLIF"]
        },
        "identification_complete": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LRDIFUDDirector", "ZonalLIF"],
        },
        letter_ref_no_submitted: {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LRDIFUDDirector", "ZonalLIF"]
        },
        team_assigned: {
            "team_assigned": ["LegalResearchCoordinator", "LRDIFUDDirector", "ZonalLIF"]
        },
        internal_traning_request_submitted: {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LRDIFUDDirector", "ZonalLIF"]
        },
    },
    "registrar_forward_to_coordinator": {
        additional_info_submitted: {
            "sent_to_registrar": ["Registrar"],
        },
    },
    "prosecutor_forward_to_director": {
        "draft_non_ensential": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor"]
        },
    },
    "prosecutor_forward_to_coordinator": {
        Submitted: {
            "assigned_to_prosecutor": ["LegalResearchProsecutor"]
        },
        "additional_info_responded": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor"]
        },
        "draft_submitted": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor"]
        },
        "public_and_amended_file_submitted": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor"]
        },
        "Draft Prepared": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor"]
        },
        "proposal_submitted": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor"],
        },
        "audit_completed": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor"],
        },
        "summary_submitted": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor"],
        },
        training_manual_submitted: {
            "assigned_to_prosecutor": ["LegalResearchProsecutor"],
        },
        outcome_submitted: {
            "assigned_to_prosecutor": ["LegalResearchProsecutor"],
        },
    },
    "identification_complete_forward": {
        "identification_in_progress": {
            "assigned_to_prosecutor": ["LRDIFUDDirector", "LegalResearchCoordinator", "LRDIFUDeputy", "ZonalLIF"],
            "forwarded_to_head": ["LRDIFUDDirector", "LegalResearchCoordinator", "LRDIFUDeputy", "ZonalLIF"],
        },
    },
    // removed because of 2 forward buttons on legeslative draft law upload
    //edit_prosecutor_forward_to_coordinator: {
    //   "draft_submitted": {
    //      "assigned_to_prosecutor": ["LegalResearchProsecutor"]
    // }
    //},

    "additional_info": {
        "Waiting for Additional Information": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor"],
            "forwarded_to_coordinator": ["LegalResearchCoordinator"],
            "sent_to_registrar": ["LegalResearchCoordinator", "Registrar"],
            not_forwarded: ["external", "GeneralAttorney", "LRDIFUDDirector", "LegalResearchCoordinator", "LegalResearchProsecutor"]
        },
        "additional_info_responded": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator"],
            "assigned_to_prosecutor": ["LegalResearchProsecutor"]
        },
        additional_info_submitted: {
            assigned_to_prosecutor: ["external", "GeneralAttorney", "LRDIFUDDirector", "LegalResearchCoordinator", "LegalResearchProsecutor"],
            not_forwarded: []
        },
    },
    "additional_info_action": {
        "Waiting for Additional Information": {
            "sent_to_registrar": ["LegalResearchCoordinator", "Registrar"],
            "assigned_to_prosecutor": ["LegalResearchProsecutor"]
        },
    },
    "additional_info_forward_to_stakeholder": {
        "Waiting for Additional Information": {
            "sent_to_registrar": ["LegalResearchCoordinator", "Registrar"],
        },
    },
    "edit_additional_info": {
        "Waiting for Additional Information": {
            not_forwarded: [],
            assigned_to_prosecutor: ["external"]
        },
        "additional_info_requested": {
            assigned_to_prosecutor: ["external"]
        },
        additional_info_submitted: {
            not_forwarded: []
        },
    },
    "additional_info_submitted": {
        additional_info_submitted: {
            all: ["stakeholder", "Registrar", "GeneralAttorney", "LRDIFUDDirector", "LegalResearchCoordinator", "LegalResearchProsecutor"]
        },
    },
    "draft_non_essential": {
        "draft_non_ensential": {
            all: ["stakeholder", "Registrar", "GeneralAttorney", "LRDIFUDDirector", "LegalResearchCoordinator", "LegalResearchProsecutor"],
            "forwarded_to_director": ["LRDIFUDDirector"],
        },
    },
    "draft_and_additional_file": {
        all: {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"]
        },
        "pending": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"]
        },
        "identification_in_progress": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"]
        },
        "team_appointed": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"]
        },
        "proposal_submitted": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"],
        },
        "proposal_responded": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"],
        },
        "audit_in_progress": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"],
        },
        "audit_completed": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"],
        },
        "audit_responded": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"],
        },
        "summary_submitted": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"],
        },
        "session_scheduled": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"],
        },
    },

    "forward_darft": {
    },
    "forward_darft_to_director": {
        "draft_submitted": {
            "forwarded_to_director": ["LRDIFUDDirector", "ZonalLIF"],
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "ZonalLIF"],
        },
        "Draft Prepared": {
            "forwarded_to_director": ["LRDIFUDDirector", "ZonalLIF"],
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "ZonalLIF"],
        },
        "proposal_submitted": {
            "forwarded_to_director": ["LRDIFUDDirector", "ZonalLIF"],
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "ZonalLIF"],
        },
        "audit_completed": {
            "forwarded_to_director": ["LRDIFUDDirector", "ZonalLIF"],
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "ZonalLIF"],
        },
    },
    "forward_darft_to_head": {
        "draft_submitted": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy", "ZonalLIF"],
        },
        "Draft Prepared": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy", "ZonalLIF"],
        },
        "proposal_submitted": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy", "ZonalLIF"],
        },
        "audit_completed": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy", "ZonalLIF"],
        },
        "public_and_amended_file_submitted": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy", "ZonalLIF"],
        },
    },

    "edit_reference_number": {
        "Draft Approved": {
            "sent_to_registrar": ["Registrar"],
        },
        "Approved by LDCCM": {
            "sent_to_registrar": ["Registrar"],
        },
        "Approved by Head": {
            "sent_to_registrar": ["Registrar"],
        },
        cafffee_aproval: {
            "sent_to_registrar": ["Registrar"],
            "forwarded_to_director": ["Registrar"],
        },
        traning_request_submitted: {
            "sent_to_registrar": ["Registrar"],
        },
        internal_traning_request_submitted: {
            "sent_to_registrar": ["Registrar"],
        },
        "Final Approval": {
            "sent_to_registrar": ["Registrar"],
        },
        "finalization_complete": {
            "sent_to_registrar": ["Registrar"],
        },
        "letter_refnum_submitted": {
            "forwarded_to_director": ["Registrar"],
        },
        "completed": {
            "forwarded_to_director": ["Registrar"],
        },
        "forwarded_to_director": {
            "forwarded_to_director": ["Registrar"],
        },
    },
    /*"public_and_amended": {
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    "letter_refnum_submitted": {
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    "assigned_to_prosecutor": ["LegalResearchProsecutor"],
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    },
    }, retired due to the new change saying coordinator uploads public, ammended & audit*/

    "public_and_amended": {
        "allow_public_feedback": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LRDIFUDDirector", "ZonalLIF"],
        },
    },

    "edit_audit_draft": {
        "public_and_amended_file_submitted": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LRDIFUDDirector", "ZonalLIF"],
        },
    },

    "final_approval": {
        "audit_submitted": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy", "ZonalLIF"],
        },
    },

    "oagb_management_head_approve_respond": {
        "audit_completed": {
            "forwarded_to_management": ["OAGBManagementHead"]
        }
    },

    "publish": {
        "archived": {
            "forwarded_to_director": ["LRDIFUDDirector", "ZonalLIF"],
        }
    },
    "archived": {
        "archived": {
            "forwarded_to_coordinator": ["LRDIFUDDirector", "LegalResearchCoordinator", "LegalResearchProsecutor", "ZonalLIF"],
            "assigned_to_prosecutor": ["LRDIFUDDirector", "LegalResearchCoordinator", "LegalResearchProsecutor", "ZonalLIF"],
        }
    },
    "broadcasted": {
        "Published": {
            not_forwarded: ["GeneralAttorney", "LegalResearchCoordinator", "LegalResearchProsecutor", "ZonalLIF"]
        }
    },
    "upload_audit_target": {
        "identification_in_progress": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"],
        },
        "pending": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"],
        },
        "summary_submitted": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"],
        },
    },
    "team_appointed": {
        "team_appointed": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"],
        },
        "proposal_submitted": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"],
        },
        "proposal_responded": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"],
        },
    },
    "upload_audit": {
        "audit_in_progress": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"],
        },
        "audit_completed": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"],
        },
        "audit_responded": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"],
        },
    },
    approve_or_schedule: {
        "summary_approved": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator"],
        },
        outcome_submitted: {
            "forwarded_to_coordinator": ["LegalResearchCoordinator"],
        }
    },

    approve_or_respond: {
        "summary_submitted": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LRDIFUDDirector"],
            "forwarded_to_director": ["LRDIFUDDirector"],
        },
    },
    schedule_awareness: {
        "summary_approved": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator"],
        }
    },
    awareness_outcome: {
        "session_scheduled": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor"],
        },
    },

    training_manual_approve: {
        "training_manual_submitted": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator"],
        },
    },

    training_manual_approved: {
        "approved": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator"],
        },
    },
    training_schedule: {
        "training_scheduled": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LegalResearchProsecutor"],
        },
        "all": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LegalResearchProsecutor"],
        }
    },
    training_feedback: {
        "training_scheduled": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor"],
        },
        "final": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor"],
            "forwarded_to_coordinator": ["LRDIFUDDirector", "LegalResearchCoordinator", "LegalResearchProsecutor"],
        },
    },
    distribute_to_zone: {
        summary_approved: {
            "forwarded_to_coordinator": ["LRDIFUDDirector", "LegalResearchCoordinator"],
        },
    },
    edit_assigned_team: {
        "director_remark_submitted": {
            "assigned_to_prosecutor": ["LRDIFUDDirector", "LegalResearchCoordinator", "ZonalLIF"],
        },
        "coordinator_remark_submitted": {
            "assigned_to_prosecutor": ["LRDIFUDDirector", "LegalResearchCoordinator", "ZonalLIF"],
        },
    },
    edit_target_approve: {
        "identification_in_progress": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LRDIFUDDirector", "LRDIFUDeputy", "ZonalLIF"],
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy", "ZonalLIF"],
        },
    },

    respond_amended: {
        "audit_responded": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LRDIFUDDirector", "ZonalLIF"],
        }
    },
};

export function CanShow(
    ui_key: string,
    currentStatus: string,
    forwardStatus?: string,
): boolean {
    const contextData = useAuth();
    const userRoles = contextData?.user?.roles || [];
    const userType = contextData?.user?.user_type;

    const forwardKey = forwardStatus || "none";
    const forwardRules = VISIBILITY_RULES[ui_key]?.[currentStatus]?.[forwardKey];

    if (!forwardRules) return false;


    if (userType === "external") {
        return forwardRules.length === 0 || 
               !!forwardRules.some(role => role.includes("stakeholder")) ||
               !!forwardRules.some(role => role === "external");
    }
    return forwardRules.some(role => 
        userRoles.some((userRole: string) => userRole.toLowerCase() === role.toLowerCase())
    );
}

export default function ShowUI({ ui_key, currentStatus, forwardStatus, children }: any) {
    return CanShow(ui_key, currentStatus, forwardStatus) ? children : null;
}
